// Tipos e tamanhos de mídia suportados pela Meta WhatsApp Cloud API.
// Centralizado para uso nos componentes de chat (chat.vue, geochat-chat.vue,
// chat-dialog.vue e geochat-dialog.vue).

export const metaMaxImageSize = 4718592; // 4.5 MB
export const metaMaxVideoSize = 16252928; // 15.5 MB
export const metaMaxDocumentSize = 67108864; // 64 MB

export const metaImageVideoTypes: string[] = [
  'image/jpg', 'image/jpeg', 'image/png', 'video/mp4', 'video/3gpp',
];

export const metaPhotoAndVideoTypesAndSizes: Record<string, number> = {
  'image/jpg': metaMaxImageSize,
  'image/jpeg': metaMaxImageSize,
  'image/png': metaMaxImageSize,
  'video/mp4': metaMaxVideoSize,
  'video/3gpp': metaMaxVideoSize,
};

export const metaDocumentTypesAndSizes: Record<string, number> = {
  'application/pdf': metaMaxDocumentSize,
  'application/msword': metaMaxDocumentSize,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': metaMaxDocumentSize,
  'application/vnd.ms-excel': metaMaxDocumentSize,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': metaMaxDocumentSize,
  'application/vnd.ms-powerpoint': metaMaxDocumentSize,
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': metaMaxDocumentSize,
  'text/plain': metaMaxDocumentSize,
  'application/xml': metaMaxDocumentSize,
  'text/xml': metaMaxDocumentSize,
};

export const metaPhotoAndVideoAccept = 'image/jpg, image/jpeg, image/png, video/mp4, video/3gpp';

export const metaDocumentAccept = [
  '.pdf', 'application/pdf',
  '.doc', 'application/msword',
  '.docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.xls', 'application/vnd.ms-excel',
  '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.ppt', 'application/vnd.ms-powerpoint',
  '.pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  '.txt', 'text/plain',
  '.xml', 'application/xml', 'text/xml',
].join(',');

export const metaSupportedMediaTypes: string[] = [
  'image/jpg', 'image/jpeg', 'image/png', 'image/webp',
  'video/mp4', 'video/3gpp',
  'audio/aac', 'audio/mp4', 'audio/mpeg', 'audio/amr', 'audio/ogg', 'audio/opus',
  ...Object.keys(metaDocumentTypesAndSizes),
];

export const metaFriendlyDocumentExtensions = '.pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .xml';

export const metaFriendlyAllExtensions = `${metaFriendlyDocumentExtensions}, `
  + '.jpg, .png, .webp, .mp4, .3gpp, .mp3, .m4a, .aac, .amr, .ogg, .opus';
